/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CustomInfoKinds {
    Warning = 1,
    Hint = 2,
}
